import { styled } from 'styled-system/jsx'

const PageStack = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    width: '100%',
  },
})

const PageHeader = styled('div', {
  base: {},
})

const PageTitle = styled('h1', {
  base: {
    fontFamily: 'display',
    fontSize: '28px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const PageSubtitle = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '15px',
    color: 'quickpass.inkSoft',
    marginTop: '4px',
  },
})

const QuietText = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
  },
})

const AnnouncementList = styled('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
})

const AnnouncementHeaderRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    alignItems: 'baseline',
    justifyContent: 'space-between',
  },
})

const AnnouncementTitle = styled('h2', {
  base: {
    fontFamily: 'display',
    fontSize: '17px',
    fontWeight: '700',
    color: 'quickpass.ink',
  },
})

const AnnouncementDate = styled('span', {
  base: {
    fontFamily: 'body',
    fontSize: '12px',
    color: '#8A8398',
  },
})

const AnnouncementBody = styled('p', {
  base: {
    fontFamily: 'body',
    fontSize: '14px',
    color: 'quickpass.inkSoft',
    lineHeight: '1.5',
    marginTop: '8px',
    whiteSpace: 'pre-wrap',
  },
})

const AcknowledgeRow = styled('div', {
  base: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: '10px',
    marginTop: '14px',
  },
})

const AcknowledgeRequiredTag = styled('span', {
  base: {
    alignSelf: 'flex-start',
    paddingX: '8px',
    paddingY: '2px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '11px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.4px',
    backgroundColor: '#FFF4D6',
    color: '#8A6D1A',
  },
})

const AcknowledgeButton = styled('button', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    paddingX: '16px',
    paddingY: '8px',
    borderRadius: 'pill',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#FFFFFF',
    backgroundColor: 'quickpass.primary',
    border: 'none',
    cursor: 'pointer',
    transition: 'opacity {durations.fast} {easings.appleStandard}',
    _hover: { opacity: '0.88' },
    _disabled: { opacity: '0.6', cursor: 'default' },
  },
})

const AcknowledgedNote = styled('span', {
  base: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: '6px',
    fontFamily: 'body',
    fontSize: '13px',
    fontWeight: '600',
    color: '#1E7A4D',
  },
})

export {
  PageStack,
  PageHeader,
  PageTitle,
  PageSubtitle,
  QuietText,
  AnnouncementList,
  AnnouncementHeaderRow,
  AnnouncementTitle,
  AnnouncementDate,
  AnnouncementBody,
  AcknowledgeRow,
  AcknowledgeRequiredTag,
  AcknowledgeButton,
  AcknowledgedNote,
}
